import { v4 as uuidv4 } from 'uuid';

export function Reviews() {
	return {
		componentName: 'Reviews',
		componentId: uuidv4(),
		props: {},
		childrenComponents: [],
	};
}
